import React from 'react'
import { Col, Spin, Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import MyOrganizations from './components/MyOrganizations'
import SutazOdovzdavaniaNacas from './SutazOdovzdavaniaNacas'

const { TabPane } = Tabs

const SuperAdminDetail = () => {
	const { t } = useTranslation('pages')

	return (
		<div className={ 'page-wrapper' }>
			<Spin spinning={ false }>
				<Col className={'grid mt-4'}>
					<div className={'flex direction-col justify-start main-content'}>
						<h3 className={'ml-2'}>{t('pages:My organization')}</h3>
						<Tabs defaultActiveKey={'prehlad'} className={'ml-2'}>
							<TabPane tab={t('pages:Prehľad')} key={'prehlad'}>
								<MyOrganizations />
							</TabPane>
							<TabPane tab={t('pages:Reporty')} key={'reporty'}>
								<SutazOdovzdavaniaNacas />
							</TabPane>
						</Tabs>
					</div>
				</Col>
			</Spin>
		</div>
	)
}

export default SuperAdminDetail
